import React from 'react'
import { useState, useCallback, useEffect, useMemo } from 'sb-hooks'
import { Field } from 'sb-formx'

import RadioGroupContext from '../RadioGroupContext/RadioGroupContext'
import RadioGroupContainer, { RadioGroupContainerProps } from '../RadioGroupContainer/RadioGroupContainer'


export type RadioGroupProps = RadioGroupContainerProps & {
  children: React.ReactNode
  field?: Field
  onChange?: (value: string | number) => void
}

const RadioGroup: React.FunctionComponent<RadioGroupProps> = (props) => {
  const { children, className, field, onChange, dataTestId, ariaLabel, ariaLabelledBy } = props
  const [ value, setValue ] = useState(field.value)

  const handleChange = useCallback((event) => {
    const { value } = event.target

    field.set(value)

  }, [ field ])

  useEffect(() => {
    const handleFieldChange = (newValue) => {
      setValue(newValue)

      if (typeof onChange === 'function') {
        onChange(newValue)
      }
    }

    field.on('change', handleFieldChange)

    return () => {
      field.off('change', handleFieldChange)
    }
  }, [ field, setValue, onChange ])

  const context = useMemo(() => ({
    name: field.name,
    activeValue: value,
    onChange: handleChange,
  }), [ field.name, value, handleChange ])

  return (
    <RadioGroupContext.Provider value={context}>
      <RadioGroupContainer
        className={className}
        ariaLabel={ariaLabel}
        ariaLabelledBy={ariaLabelledBy}
        dataTestId={dataTestId}
      >
        {children}
      </RadioGroupContainer>
    </RadioGroupContext.Provider>
  )
}


export default RadioGroup
